import { AnnouncementAPIModel, PaginatedAPI } from 'src/app/models/api.model'

export interface AnnouncementState {
  summary: PaginatedAPI<AnnouncementAPIModel>
  details: AnnouncementAPIModel
}

export const initialAnnouncementState: AnnouncementState = {
  summary: undefined,
  details: undefined
}
